export enum MerchantApplicationStatus {
  Initiated = 'Initiated',
  Disqualified = 'Disqualified',
  Prequalified = 'Prequalified',
  UserCreated = 'UserCreated',
  Submitted = 'Submitted',
  Approved = 'Approved',
  Declined = 'Declined',
  Onboarded = 'Onboarded',
}

export interface MerchantApplicationResponse {
  applicationId?: string;
  status?: MerchantApplicationStatus;
  applicant_user_id?: string | null;
  applicantUserId?: string | null;
  signUpInfo?: SignUpInfoResponse | null;
  businessDetails?: BusinessDetailsResponse | null;
  directorDetails: DirectorDetailsResponse | null;
  settlementDetails: SettlementDetails | null;
  aiPrefilling?: MerchantApplicationAIPrefillingResponse | null;
  salesforceSdocContractUrl?: string;
}

export interface SignUpInfoResponse {
  firstName?: string | null;
  referrer?: string | null;
  paymentType?: string | null;
}

export interface BusinessDetailsResponse {
  businessAddress?: AddressResponse;
  isPartOfFranchise?: boolean;
  hasMultipleLocations?: boolean;
  averageTransactionValue?: string;
  costOfLargestProductOrService?: string;
  averageShippingTimeFrame?: string;
  hasShippingPolicy?: boolean;
  hasRefundPolicy?: boolean;
  providesService?: boolean;
  fullPaymentTakeTime?: string;
}

export interface AddressResponse {
  unitNumber?: string;
  streetNumber?: string;
  streetName?: string;
  suburb?: string;
  postcode?: string;
  state?: string;
}

export enum IdentityDocumentType {
  DriversLicence = 'DriversLicence',
  Passport = 'Passport',
  BankStatement = 'BankStatement',
}

export interface DriversLicenceResponse {
  state?: string | null;
  licenceNumber?: string | null;
  cardNumber?: string | null;
}

export interface PassportResponse {
  country?: string | null;
  passportNumber?: string | null;
}

export interface DirectorDetailsResponse {
  identityDocumentUsed?: IdentityDocumentType | null;
  identityDocumentStorage?: string[] | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  businessEmail?: string | null;
  mobileNumber?: string | null;
  dateOfBirth?: string | null;
  residentialAddress?: AddressResponse | null;
  driversLicence?: DriversLicenceResponse | null;
  passport?: PassportResponse | null;
}

export interface SettlementDetails {
  bank?: string | null;
  bankStatementStorage?: string | null;
  bsb?: string | null;
  accountNumber?: string | null;
  disbursementEmail?: string | null;
  accountName?: string | null;
  directDebitAgreementSigned?: boolean | null;
  directDebitAgreementSignedTimeStamp?: string | null;
}

export interface MerchantApplicationAIPrefillingResponse {
  businessInfo?: BusinessDetailsAISuggestionResponse | null;
}

export interface BusinessDetailsAISuggestionResponse {
  url?: string | null;
  applicationId?: string | null;
  franchiseGroup?: boolean | null;
  franchiseGroupConfidence?: string | null;
  multipleLocations?: boolean | null;
  multipleLocationsConfidence?: string | null;
  avgTransactionValue?: string | null;
  avgTransactionValueConfidence?: string | null;
  costOfLargestProduct?: string | null;
  costOfLargestProductConfidence?: string | null;
  avgShipTime?: string | null;
  avgShipTimeConfidence?: string | null;
  shippingPolicy?: boolean | null;
  shippingPolicyConfidence?: string | null;
  returnPolicy?: boolean | null;
  returnPolicyConfidence?: string | null;
  businessLocation?: string | null;
  businessLocationConfidence?: string | null;
}

export const ActivationProgressStatus = {
  Upload: 'Upload',
  Edit: 'Edit',
  Confirmed: 'Confirmed',
  EditStepA: 'EditStepA',
  EditStepB: 'EditStepB',
  EditStepC: 'EditStepC',
} as const;

export type ActivationProgressStatus =
  (typeof ActivationProgressStatus)[keyof typeof ActivationProgressStatus];

export interface MerchantApplicationProgressResponse {
  businessDetails?: ActivationProgressStatus;
  directorDetails?: ActivationProgressStatus;
  settlementDetails?: ActivationProgressStatus;
  businessDetailsStepAAIConfirmed?: boolean;
  businessDetailsStepBAIConfirmed?: boolean;
  businessDetailsStepCAIConfirmed?: boolean;
}
